import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import MetaTags from '../components/MetaTags';
import { getAuditionListingSchema } from '../utils/schemaGenerator';
import { useTheme } from '../context/ThemeContext';

const CastingPage = () => {
  const { theme } = useTheme();
  const castingSchema = getAuditionListingSchema([], "Casting Calls & Auditions", "https://web.bookmyaudition.com/castings");

  return (
    <>
      <MetaTags
        title="Open Casting Calls & Performance Roles | BookMyAudition"
        description="Explore open casting calls from verified directors and producers in India. Find roles for actors, models, singers, and dancers."
        keywords="casting calls, open casting calls, actor casting calls, Bollywood casting calls, web series casting calls, TV serial auditions"
        canonical="https://web.bookmyaudition.com/castings"
        schema={castingSchema}
      />
      <div 
        className="casting-page" 
        style={{ 
          minHeight: '70vh', 
          padding: '60px 0',
          backgroundColor: theme === 'dark' ? '#0a0a14' : '#f8fafc',
          color: theme === 'dark' ? '#f8fafc' : '#111'
        }}
      >
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h1 className="fw-bold mb-4" style={{ color: theme === 'dark' ? '#fff' : '#111' }}>
                Latest Casting Calls
              </h1>
              <p style={{ color: theme === 'dark' ? '#cbd5e1' : '#475569', fontSize: '1.1rem' }}>
                Explore open casting calls from verified directors and producers. Filter by location, role type, and experience level.
              </p>
              
              <div 
                className="coming-soon-box mt-5 p-5 rounded-4 shadow-sm"
                style={{
                  backgroundColor: theme === 'dark' ? '#111116' : '#fff',
                  border: `1px solid ${theme === 'dark' ? '#1f1f2e' : '#eaeaea'}`
                }}
              >
                <h3 className="fw-bold mb-3">Coming Soon</h3>
                <p className="text-muted">
                  We are curating high-profile casting calls directly from top production houses across Mumbai, Delhi, and Bangalore.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default CastingPage;
